import { render } from "./AddOrEditEventPopup.vue?vue&type=template&id=35e1c792&ts=true"
import script from "./AddOrEditEventPopup.vue?vue&type=script&lang=ts"
export * from "./AddOrEditEventPopup.vue?vue&type=script&lang=ts"

import "./AddOrEditEventPopup.vue?vue&type=style&index=0&id=35e1c792&lang=sass"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__